import React, {  useState } from "react";
import { useNavigate } from "react-router-dom";

import { getTrans as t } from "../../../Localization/translations";
import Helper from "../../../Helper";

function PendingContracts({ contract,customerPermission }) {
  const [permissionss, setPermission] = useState(
    localStorage.getItem("permissions")
  );
  const permissionsArray = permissionss && permissionss.split(",");
  let navigate = useNavigate();

  const handleView = (id, contract_type) => {
    if (contract_type === "Loan") {
      navigate("/editloancontract", { state: id });
    } else if (contract_type === "Line of Credit") {
      navigate("/edit-line-of-credit-contract", { state: id });
    } else {
      navigate("/contract/edit", { state: id });
    }
  };

  return (
      <div className="">
        <div className="body px-0 pb-2">
          <div className="table-responsive">
            <table
              className="table table-striped align-items-center mb-0"
              style={{ background: "white" }}
            >
              <thead>
                <tr>
                  <th className="text-uppercase text-left text-secondary text-xxs font-weight-bolder opacity-7">
                    {t("CONTRACT NUMBER")}
                  </th>
                  <th className="text-uppercase text-left text-secondary text-xxs font-weight-bolder opacity-7 ">
                    {t("CUSTOMER NAME")}
                  </th>
                  <th className="text-left text-uppercase text-secondary text-xxs font-weight-bolder  opacity-7">
                    {t("AMOUNT FINANCED")}
                  </th>
                  <th className="text-left text-uppercase text-secondary text-xxs font-weight-bolder  opacity-7">
                    {t("TERM")}
                  </th>
                  <th className="text-left text-uppercase text-secondary text-xxs font-weight-bolder  opacity-7">
                    {t("START DATE")}
                  </th>
                  <th className="text-left text-uppercase text-secondary text-xxs font-weight-bolder  opacity-7">
                    {t("STATUS")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {contract.map((key) => (
                  <tr>
                    <td className="align-middle text-left ">
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">
                          {t("CONTRACT NUMBER")}
                        </div>
                        <div>
                          <span
                            onClick={() =>
                            permissionss && permissionsArray.includes('change_contract')===true ?
                            customerPermission !== 'Customer' && handleView(key.id, key.contract_type) :""
                            }
                            className="hyperlink"
                          >
                            {key.contract_number}
                          </span>
                        </div>
                      </>
                    </td>
                    <td className="text-left">
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">
                          {t("CUSTOMER NAME")}
                        </div>
                        <div>{key.customer_name}</div>
                      </>
                    </td>
                    <td className="align-middle text-left ">
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">
                          {t("AMOUNT FINANCED")}
                        </div>
                        <div>{Helper.Amount(key.financed_amount)}</div>
                      </>
                    </td>
                    <td className="align-middle text-left">
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">{t("TERM")} </div>
                        <div>{key.contract_term}</div>
                      </>
                    </td>
                    <td className="align-middle text-left">
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">{t("START DATE")} </div>
                        <div>{Helper.DateNormal(key.start_date)}</div>
                      </>
                    </td>
                    <td className="align-middle text-left">
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">{t("STATUS")} </div>
                        <div className="badge bg-gradient-secondary text-xxs ">
                          {key.status}
                        </div>
                      </>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
  );
}

export default PendingContracts;
